import './projects.css';
import AllProjects from '../../Components/Projects/allProjects';
import { FaGithub } from "react-icons/fa6";
import { NavLink } from 'react-router-dom';
import { CgWebsite } from "react-icons/cg";
import { motion } from 'framer-motion'; // Import motion from framer-motion

function Projects() {
    return (
        <div className="background">
            <h1 className='text-center text-white my-3 name'>Projects</h1>
            <div className="container ">
                <div className="row row-cols-1 row-cols-md-3 g-5 my-5 d-flex justify-content-center ">
                    {/* Map through the projects */}
                    {AllProjects.map((project, index) => (
                        <motion.div
                            className="col my-3"
                            key={index}
                            initial={{ opacity: 0, y: -50 }} // Start with hidden state
                            whileInView={{ opacity: 1, y: 0 }} // Animate to visible
                            transition={{
                                duration: 0.3, 
                                delay: index * 0.1, // Delay each column based on index
                                type: 'spring', // Spring animation for smoothness
                                stiffness: 100
                            }}
                        >
                            <div className="card">
                                {/* <img src="..." className="card-img-top" alt="..." /> */}
                                <div className="card-body">
                                    <h4 className="text-center text-white name">{project.title}</h4>
                                    <h5 className="text-white">{project.technology}</h5>
                                    <p className="card-text text-white">{project.description}</p>
                                </div>
                                <div className="card-footer d-flex justify-content-around">
                                    <NavLink to={project.linkGithup}>
                                        <button type="button" className="buttonIcon">
                                            <FaGithub className='mx-2 mb-1' />GitHub
                                        </button>
                                    </NavLink>
                                    <NavLink to={project.linkDemo}>
                                        <button type="button" className="buttonIcon">
                                            <CgWebsite className='mx-2 mb-1' />Demo
                                        </button>
                                    </NavLink>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Projects;
